/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
// URGENTE: en iPhone se descarga "cart" si el botón va a /cart.
// Forzamos que cualquier checkout del drawer vaya a /checkout.
document.addEventListener(
  "click",
  function (e) {
    // Solo dentro del footer del carrito lateral
    const footer = e.target.closest(".cart-drawer__foot, #CartDrawer, .drawer--cart");
    if (!footer) return;

    const el = e.target.closest("a, button");
    if (!el) return;

    const txt = (el.textContent || "").trim().toLowerCase();
    const href = (el.getAttribute && el.getAttribute("href")) ? el.getAttribute("href") : "";

    // Detecta el CTA principal de checkout por texto o clase típica
    const looksLikeCheckout =
      txt.includes("check out") ||
      txt.includes("checkout") ||
      txt.includes("pagar") ||
      txt.includes("finalizar") ||
      el.classList.contains("cart__checkout");

    // No interceptar el botón de eliminar ítem (X): debe manejarlo el tema por AJAX
    if (el.closest("[data-item-remove]")) return;

    // Si el elemento o su href huele a /cart (causa del "descargar cart"), lo bloqueamos
    const looksLikeCartHref = href && (href === "/cart" || href.startsWith("/cart?") || href.startsWith("/cart"));

    if (looksLikeCheckout || looksLikeCartHref) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = "/checkout";
    }
  },
  true
);
